
import { combineReducers } from 'redux';
import { foreignExchangeRate } from './foreign-exchange-rate/foreignExchangeRate.reducer';
import { scope3Benchmark } from './scope3-benchmark/scope3Benchmark.reducer';
import { performanceFeedback } from './performance-feedback/performanceFeedback.reducer';
import { performanceSubscription } from './performance-subscription/performanceSubscription.reducer';
import { log } from './log/log.reducer';
import { dominosBasketSize } from "./dominos_basket_size/dominosBasketSize.reducer"
import { dominosMasterCampaign } from "./dominos-master-campaign/dominosMasterCampaign.reducer"
import { analytics } from './analytics-v2/analytics.reducer';
import { cmp } from './commercial-model-pricing/cmp.reducer';

export const others = combineReducers({ foreignExchangeRate, log, scope3Benchmark, performanceFeedback, performanceSubscription, dominosBasketSize, dominosMasterCampaign, analytics, cmp });
